var DuckDB = (() => {
    var _scriptDir = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : undefined;
    if (typeof __filename !== 'undefined') _scriptDir = _scriptDir || __filename;
    return (
        function(moduleArg = {}) {

            var Module = moduleArg;
            var readyPromiseResolve, readyPromiseReject;
            Module["ready"] = new Promise((resolve, reject) => {
                readyPromiseResolve = resolve;
                readyPromiseReject = reject
            });
            var moduleOverrides = Object.assign({}, Module);
            var arguments_ = [];
            var thisProgram = "./this.program";
            var quit_ = (status, toThrow) => {
                throw toThrow
            };
            var ENVIRONMENT_IS_WEB = typeof window == "object";
            var ENVIRONMENT_IS_WORKER = typeof importScripts == "function";
            var ENVIRONMENT_IS_NODE = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string";
            var scriptDirectory = "";

            function locateFile(path) {
                if (Module["locateFile"]) {
                    return Module["locateFile"](path, scriptDirectory)
                }
                return scriptDirectory + path
            }
            var read_, readAsync, readBinary, setWindowTitle;
            if (ENVIRONMENT_IS_NODE) {
                var fs = require("fs");
                var nodePath = require("path");
                if (ENVIRONMENT_IS_WORKER) {
                    scriptDirectory = nodePath.dirname(scriptDirectory) + "/"
                } else {
                    scriptDirectory = __dirname + "/"
                }
                read_ = (filename, binary) => {
                    filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
                    return fs.readFileSync(filename, binary ? undefined : "utf8")
                };
                readBinary = filename => {
                    var ret = read_(filename, true);
                    if (!ret.buffer) {
                        ret = new Uint8Array(ret)
                    }
                    return ret
                };
                readAsync = (filename, onload, onerror, binary = true) => {
                    filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
                    fs.readFile(filename, binary ? undefined : "utf8", (err, data) => {
                        if (err) onerror(err);
                        else onload(binary ? data.buffer : data)
                    })
                };
                if (!Module["thisProgram"] && process.argv.length > 1) {
                    thisProgram = process.argv[1].replace(/\\/g, "/")
                }
                arguments_ = process.argv.slice(2);
                quit_ = (status, toThrow) => {
                    process.exitCode = status;
                    throw toThrow
                };
                Module["inspect"] = () => "[Emscripten Module object]"
            } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
                if (ENVIRONMENT_IS_WORKER) {
                    scriptDirectory = self.location.href
                } else if (typeof document != "undefined" && document.currentScript) {
                    scriptDirectory = document.currentScript.src
                }
                if (_scriptDir) {
                    scriptDirectory = _scriptDir
                }
                if (scriptDirectory.indexOf("blob:") !== 0) {
                    scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1)
                } else {
                    scriptDirectory = ""
                } {
                    read_ = url => {
                        var xhr = new XMLHttpRequest;
                        xhr.open("GET", url, false);
                        xhr.send(null);
                        return xhr.responseText
                    };
                    if (ENVIRONMENT_IS_WORKER) {
                        readBinary = url => {
                            var xhr = new XMLHttpRequest;
                            xhr.open("GET", url, false);
                            xhr.responseType = "arraybuffer";
                            xhr.send(null);
                            return new Uint8Array(xhr.response)
                        }
                    }
                    readAsync = (url, onload, onerror) => {
                        var xhr = new XMLHttpRequest;
                        xhr.open("GET", url, true);
                        xhr.responseType = "arraybuffer";
                        xhr.onload = () => {
                            if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                                onload(xhr.response);
                                return
                            }
                            onerror()
                        };
                        xhr.onerror = onerror;
                        xhr.send(null)
                    }
                }
                setWindowTitle = title => document.title = title
            } else {}
            var out = Module["print"] || console.log.bind(console);
            var err = Module["printErr"] || console.error.bind(console);
            Object.assign(Module, moduleOverrides);
            moduleOverrides = null;
            if (Module["arguments"]) arguments_ = Module["arguments"];
            if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
            if (Module["quit"]) quit_ = Module["quit"];
            var wasmBinary;
            if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
            var noExitRuntime = Module["noExitRuntime"] || true;
            if (typeof WebAssembly != "object") {
                abort("no native wasm support detected")
            }
            var wasmMemory;
            var ABORT = false;
            var EXITSTATUS;

            function assert(condition, text) {
                if (!condition) {
                    abort(text)
                }
            }
            var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;

            function updateMemoryViews() {
                var b = wasmMemory.buffer;
                Module["HEAP8"] = HEAP8 = new Int8Array(b);
                Module["HEAP16"] = HEAP16 = new Int16Array(b);
                Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
                Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
                Module["HEAP32"] = HEAP32 = new Int32Array(b);
                Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
                Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
                Module["HEAPF64"] = HEAPF64 = new Float64Array(b)
            }
            var wasmTable;
            var __ATPRERUN__ = [];
            var __ATINIT__ = [];
            var __ATMAIN__ = [];
            var __ATPOSTRUN__ = [];
            var runtimeInitialized = false;
            var runtimeKeepaliveCounter = 0;

            function keepRuntimeAlive() {
                return noExitRuntime || runtimeKeepaliveCounter > 0
            }

            function preRun() {
                if (Module["preRun"]) {
                    if (typeof Module["preRun"] == "function") Module["preRun"] = [Module["preRun"]];
                    while (Module["preRun"].length) {
                        addOnPreRun(Module["preRun"].shift())
                    }
                }
                callRuntimeCallbacks(__ATPRERUN__)
            }

            function initRuntime() {
                runtimeInitialized = true;
                callRuntimeCallbacks(__ATINIT__)
            }

            function preMain() {
                callRuntimeCallbacks(__ATMAIN__)
            }

            function postRun() {
                if (Module["postRun"]) {
                    if (typeof Module["postRun"] == "function") Module["postRun"] = [Module["postRun"]];
                    while (Module["postRun"].length) {
                        addOnPostRun(Module["postRun"].shift())
                    }
                }
                callRuntimeCallbacks(__ATPOSTRUN__)
            }

            function addOnPreRun(cb) {
                __ATPRERUN__.unshift(cb)
            }

            function addOnInit(cb) {
                __ATINIT__.unshift(cb)
            }

            function addOnPostRun(cb) {
                __ATPOSTRUN__.unshift(cb)
            }
            var runDependencies = 0;
            var runDependencyWatcher = null;
            var dependenciesFulfilled = null;

            function addRunDependency(id) {
                runDependencies++;
                if (Module["monitorRunDependencies"]) {
                    Module["monitorRunDependencies"](runDependencies)
                }
            }

            function removeRunDependency(id) {
                runDependencies--;
                if (Module["monitorRunDependencies"]) {
                    Module["monitorRunDependencies"](runDependencies)
                }
                if (runDependencies == 0) {
                    if (runDependencyWatcher !== null) {
                        clearInterval(runDependencyWatcher);
                        runDependencyWatcher = null
                    }
                    if (dependenciesFulfilled) {
                        var callback = dependenciesFulfilled;
                        dependenciesFulfilled = null;
                        callback()
                    }
                }
            }

            function abort(what) {
                if (Module["onAbort"]) {
                    Module["onAbort"](what)
                }
                what = "Aborted(" + what + ")";
                err(what);
                ABORT = true;
                EXITSTATUS = 1;
                what += ". Build with -sASSERTIONS for more info.";
                if (runtimeInitialized) {
                    ___trap()
                }
                var e = new WebAssembly.RuntimeError(what);
                readyPromiseReject(e);
                throw e
            }
            var dataURIPrefix = "data:application/octet-stream;base64,";

            function isDataURI(filename) {
                return filename.startsWith(dataURIPrefix)
            }

            function isFileURI(filename) {
                return filename.startsWith("file://")
            }
            var wasmBinaryFile;
            wasmBinaryFile = "./duckdb-eh.wasm";
            if (!isDataURI(wasmBinaryFile)) {
                wasmBinaryFile = locateFile(wasmBinaryFile)
            }

            function getBinarySync(file) {
                if (file == wasmBinaryFile && wasmBinary) {
                    return new Uint8Array(wasmBinary)
                }
                if (readBinary) {
                    return readBinary(file)
                }
                throw "both async and sync fetching of the wasm failed"
            }

            function getBinaryPromise(binaryFile) {
                if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
                    if (typeof fetch == "function") {
                        return fetch(binaryFile, {
                            credentials: "same-origin"
                        }).then(response => {
                            if (!response["ok"]) {
                                throw "failed to load wasm binary file at '" + binaryFile + "'"
                            }
                            return response["arrayBuffer"]()
                        }).catch(() => getBinarySync(binaryFile))
                    }
                }
                return Promise.resolve().then(() => getBinarySync(binaryFile))
            }

            function instantiateArrayBuffer(binaryFile, imports, receiver) {
                return getBinaryPromise(binaryFile).then(binary => WebAssembly.instantiate(binary, imports)).then(instance => instance).then(receiver, reason => {
                    err(`failed to asynchronously prepare wasm: ${reason}`);
                    abort(reason)
                })
            }

            function instantiateAsync(binary, binaryFile, imports, callback) {
                if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && !ENVIRONMENT_IS_NODE && typeof fetch == "function") {
                    return fetch(binaryFile, {
                        credentials: "same-origin"
                    }).then(response => {
                        var result = WebAssembly.instantiateStreaming(response, imports);
                        return result.then(callback, function(reason) {
                            err(`wasm streaming compile failed: ${reason}`);
                            err("falling back to ArrayBuffer instantiation");
                            return instantiateArrayBuffer(binaryFile, imports, callback)
                        })
                    })
                }
                return instantiateArrayBuffer(binaryFile, imports, callback)
            }

            function createWasm() {
                var info = {
                    "a": wasmImports
                };

                function receiveInstance(instance, module) {
                    var exports = instance.exports;
                    exports = applySignatureConversions(exports);
                    wasmExports = exports;
                    wasmMemory = wasmExports["ja"];
                    updateMemoryViews();
                    wasmTable = wasmExports["ma"];
                    addOnInit(wasmExports["ka"]);
                    removeRunDependency("wasm-instantiate");
                    return exports
                }
                addRunDependency("wasm-instantiate");

                function receiveInstantiationResult(result) {
                    receiveInstance(result["instance"])
                }
                if (Module["instantiateWasm"]) {
                    try {
                        return Module["instantiateWasm"](info, receiveInstance)
                    } catch (e) {
                        err(`Module.instantiateWasm callback failed with error: ${e}`);
                        readyPromiseReject(e)
                    }
                }
                instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
                return {}
            }
            var tempDouble;
            var tempI64;

            function ExitStatus(status) {
                this.name = "ExitStatus";
                this.message = `Program terminated with exit(${status})`;
                this.status = status
            }
            var callRuntimeCallbacks = callbacks => {
                while (callbacks.length > 0) {
                    callbacks.shift()(Module)
                }
            };

            function __ZN18duckdb_skiplistlib9skip_list19_throw_exceeds_sizeEm() {
                abort("missing function: _ZN18duckdb_skiplistlib9skip_list19_throw_exceeds_sizeEm")
            }
            __ZN18duckdb_skiplistlib9skip_list19_throw_exceeds_sizeEm.stub = true;

            function SOCKFS() {
                abort("missing function: $SOCKFS")
            }
            SOCKFS.stub = true;

            function FS() {
                abort("missing function: $FS")
            }
            FS.stub = true;
            var getSocketFromFD = fd => {
                var socket = SOCKFS.getSocket(fd);
                if (!socket) throw new FS.ErrnoError(8);
                return socket
            };
            var inetNtop4 = addr => (addr & 255) + "." + (addr >> 8 & 255) + "." + (addr >> 16 & 255) + "." + (addr >> 24 & 255);
            var inetNtop6 = ints => {
                var str = "";
                var word = 0;
                var longest = 0;
                var lastzero = 0;
                var zstart = 0;
                var len = 0;
                var i = 0;
                var parts = [ints[0] & 65535, ints[0] >> 16, ints[1] & 65535, ints[1] >> 16, ints[2] & 65535, ints[2] >> 16, ints[3] & 65535, ints[3] >> 16];
                var hasipv4 = true;
                var v4part = "";
                for (i = 0; i < 5; i++) {
                    if (parts[i] !== 0) {
                        hasipv4 = false;
                        break
                    }
                }
                if (hasipv4) {
                    v4part = inetNtop4(parts[6] | parts[7] << 16);
                    if (parts[5] === -1) {
                        str = "::ffff:";
                        str += v4part;
                        return str
                    }
                    if (parts[5] === 0) {
                        str = "::";
                        if (v4part === "0.0.0.0") v4part = "";
                        if (v4part === "0.0.0.1") v4part = "1";
                        str += v4part;
                        return str
                    }
                }
                for (word = 0; word < 8; word++) {
                    if (parts[word] === 0) {
                        if (word - lastzero > 1) {
                            len = 0
                        }
                        lastzero = word;
                        len++
                    }
                    if (len > longest) {
                        longest = len;
                        zstart = word - longest + 1
                    }
                }
                for (word = 0; word < 8; word++) {
                    if (longest > 1) {
                        if (parts[word] === 0 && word >= zstart && word < zstart + longest) {
                            if (word === zstart) {
                                str += ":";
                                if (zstart === 0) str += ":"
                            }
                            continue
                        }
                    }
                    str += Number(_ntohs(parts[word] & 65535)).toString(16);
                    str += word < 7 ? ":" : ""
                }
                return str
            };
            var readSockaddr = (sa, salen) => {
                var family = HEAP16[sa >>> 1 >>> 0];
                var port = _ntohs(HEAPU16[sa + 2 >>> 1 >>> 0]);
                var addr;
                switch (family) {
                    case 2:
                        if (salen !== 16) {
                            return {
                                errno: 28
                            }
                        }
                        addr = HEAP32[sa + 4 >>> 2 >>> 0];
                        addr = inetNtop4(addr);
                        break;
                    case 10:
                        if (salen !== 28) {
                            return {
                                errno: 28
                            }
                        }
                        addr = [HEAP32[sa + 8 >>> 2 >>> 0], HEAP32[sa + 12 >>> 2 >>> 0], HEAP32[sa + 16 >>> 2 >>> 0], HEAP32[sa + 20 >>> 2 >>> 0]];
                        addr = inetNtop6(addr);
                        break;
                    default:
                        return {
                            errno: 5
                        }
                }
                return {
                    family: family,
                    addr: addr,
                    port: port
                }
            };
            var inetPton4 = str => {
                var b = str.split(".");
                for (var i = 0; i < 4; i++) {
                    var tmp = Number(b[i]);
                    if (isNaN(tmp)) return null;
                    b[i] = tmp
                }
                return (b[0] | b[1] << 8 | b[2] << 16 | b[3] << 24) >>> 0
            };
            var jstoi_q = str => parseInt(str);
            var inetPton6 = str => {
                var words;
                var w, offset, z;
                var valid6regx = /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i;
                var parts = [];
                if (!valid6regx.test(str)) {
                    return null
                }
                if (str === "::") {
                    return [0, 0, 0, 0, 0, 0, 0, 0]
                }
                if (str.startsWith("::")) {
                    str = str.replace("::", "Z:")
                } else {
                    str = str.replace("::", ":Z:")
                }
                if (str.indexOf(".") > 0) {
                    str = str.replace(new RegExp("[.]", "g"), ":");
                    words = str.split(":");
                    words[words.length - 4] = jstoi_q(words[words.length - 4]) + jstoi_q(words[words.length - 3]) * 256;
                    words[words.length - 3] = jstoi_q(words[words.length - 2]) + jstoi_q(words[words.length - 1]) * 256;
                    words = words.slice(0, words.length - 2)
                } else {
                    words = str.split(":")
                }
                offset = 0;
                z = 0;
                for (w = 0; w < words.length; w++) {
                    if (typeof words[w] == "string") {
                        if (words[w] === "Z") {
                            for (z = 0; z < 8 - words.length + 1; z++) {
                                parts[w + z] = 0
                            }
                            offset = z - 1
                        } else {
                            parts[w + offset] = _htons(parseInt(words[w], 16))
                        }
                    } else {
                        parts[w + offset] = words[w]
                    }
                }
                return [parts[1] << 16 | parts[0], parts[3] << 16 | parts[2], parts[5] << 16 | parts[4], parts[7] << 16 | parts[6]]
            };
            var DNS = {
                address_map: {
                    id: 1,
                    addrs: {},
                    names: {}
                },
                lookup_name(name) {
                    var res = inetPton4(name);
                    if (res !== null) {
                        return name
                    }
                    res = inetPton6(name);
                    if (res !== null) {
                        return name
                    }
                    var addr;
                    if (DNS.address_map.addrs[name]) {
                        addr = DNS.address_map.addrs[name]
                    } else {
                        var id = DNS.address_map.id++;
                        assert(id < 65535, "exceeded max address mappings of 65535");
                        addr = "172.29." + (id & 255) + "." + (id & 65280);
                        DNS.address_map.names[addr] = name;
                        DNS.address_map.addrs[name] = addr
                    }
                    return addr
                },
                lookup_addr(addr) {
                    if (DNS.address_map.names[addr]) {
                        return DNS.address_map.names[addr]
                    }
                    return null
                }
            };
            var getSocketAddress = (addrp, addrlen, allowNull) => {
                if (allowNull && addrp === 0) return null;
                var info = readSockaddr(addrp, addrlen);
                if (info.errno) throw new FS.ErrnoError(info.errno);
                info.addr = DNS.lookup_addr(info.addr) || info.addr;
                return info
            };
            var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : undefined;
            var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead) => {
                idx >>>= 0;
                var endIdx = idx + maxBytesToRead;
                var endPtr = idx;
                while (heapOrArray[endPtr] && !(endPtr >= endIdx)) ++endPtr;
                if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
                    return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr))
                }
                var str = "";
                while (idx < endPtr) {
                    var u0 = heapOrArray[idx++];
                    if (!(u0 & 128)) {
                        str += String.fromCharCode(u0);
                        continue
                    }
                    var u1 = heapOrArray[idx++] & 63;
                    if ((u0 & 224) == 192) {
                        str += String.fromCharCode((u0 & 31) << 6 | u1);
                        continue
                    }
                    var u2 = heapOrArray[idx++] & 63;
                    if ((u0 & 240) == 224) {
                        u0 = (u0 & 15) << 12 | u1 << 6 | u2
                    } else {
                        u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63
                    }
                    if (u0 < 65536) {
                        str += String.fromCharCode(u0)
                    } else {
                        var ch = u0 - 65536;
                        str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023)
                    }
                }
                return str
            };
            var UTF8ToString = (ptr, maxBytesToRead) => {
                ptr >>>= 0;
                return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : ""
            };
            var SYSCALLS = {
                varargs: undefined,
                get() {
                    var ret = HEAP32[SYSCALLS.varargs >>> 2 >>> 0];
                    SYSCALLS.varargs += 4;
                    return ret
                },
                getp() {
                    return SYSCALLS.get()
                },
                getStr(ptr) {
                    var ret = UTF8ToString(ptr);
                    return ret
                }
            };
            var convertI32PairToI53Checked = (lo, hi) => hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;

            function ___syscall_bind(fd, addr, addrlen, d1, d2, d3) {
                addr >>>= 0;
                addrlen >>>= 0;
                var sock = getSocketFromFD(fd);
                var info = getSocketAddress(addr, addrlen);
                sock.sock_ops.bind(sock, info.addr, info.port);
                return 0
            }

            function ___syscall_connect(fd, addr, addrlen, d1, d2, d3) {
                addr >>>= 0;
                addrlen >>>= 0;
                var sock = getSocketFromFD(fd);
                var info = getSocketAddress(addr, addrlen);
                sock.sock_ops.connect(sock, info.addr, info.port);
                return 0
            }

            function ___syscall_faccessat(dirfd, path, amode, flags) {
                path >>>= 0
            }

            function ___syscall_fcntl64(fd, cmd, varargs) {
                varargs >>>= 0;
                SYSCALLS.varargs = varargs;
                return 0
            }

            function ___syscall_fstat64(fd, buf) {
                buf >>>= 0
            }

            function ___syscall_ftruncate64(fd, length_low, length_high) {
                var length = convertI32PairToI53Checked(length_low, length_high)
            }
            var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite) => {
                outIdx >>>= 0;
                if (!(maxBytesToWrite > 0)) return 0;
                var startIdx = outIdx;
                var endIdx = outIdx + maxBytesToWrite - 1;
                for (var i = 0; i < str.length; ++i) {
                    var u = str.charCodeAt(i);
                    if (u >= 55296 && u <= 57343) {
                        var u1 = str.charCodeAt(++i);
                        u = 65536 + ((u & 1023) << 10) | u1 & 1023
                    }
                    if (u <= 127) {
                        if (outIdx >= endIdx) break;
                        heap[outIdx++ >>> 0] = u
                    } else if (u <= 2047) {
                        if (outIdx + 1 >= endIdx) break;
                        heap[outIdx++ >>> 0] = 192 | u >> 6;
                        heap[outIdx++ >>> 0] = 128 | u & 63
                    } else if (u <= 65535) {
                        if (outIdx + 2 >= endIdx) break;
                        heap[outIdx++ >>> 0] = 224 | u >> 12;
                        heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
                        heap[outIdx++ >>> 0] = 128 | u & 63
                    } else {
                        if (outIdx + 3 >= endIdx) break;
                        heap[outIdx++ >>> 0] = 240 | u >> 18;
                        heap[outIdx++ >>> 0] = 128 | u >> 12 & 63;
                        heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
                        heap[outIdx++ >>> 0] = 128 | u & 63
                    }
                }
                heap[outIdx >>> 0] = 0;
                return outIdx - startIdx
            };
            var stringToUTF8 = (str, outPtr, maxBytesToWrite) => stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);

            function ___syscall_getdents64(fd, dirp, count) {
                dirp >>>= 0;
                count >>>= 0
            }
            var zeroMemory = (address, size) => {
                HEAPU8.fill(0, address, address + size);
                return address
            };
            var writeSockaddr = (sa, family, addr, port, addrlen) => {
                switch (family) {
                    case 2:
                        addr = inetPton4(addr);
                        zeroMemory(sa, 16);
                        if (addrlen) {
                            HEAP32[addrlen >>> 2 >>> 0] = 16
                        }
                        HEAP16[sa >>> 1 >>> 0] = family;
                        HEAP32[sa + 4 >>> 2 >>> 0] = addr;
                        HEAP16[sa + 2 >>> 1 >>> 0] = _htons(port);
                        break;
                    case 10:
                        addr = inetPton6(addr);
                        zeroMemory(sa, 28);
                        if (addrlen) {
                            HEAP32[addrlen >>> 2 >>> 0] = 28
                        }
                        HEAP32[sa >>> 2 >>> 0] = family;
                        HEAP32[sa + 8 >>> 2 >>> 0] = addr[0];
                        HEAP32[sa + 12 >>> 2 >>> 0] = addr[1];
                        HEAP32[sa + 16 >>> 2 >>> 0] = addr[2];
                        HEAP32[sa + 20 >>> 2 >>> 0] = addr[3];
                        HEAP16[sa + 2 >>> 1 >>> 0] = _htons(port);
                        break;
                    default:
                        return 5
                }
                return 0
            };

            function ___syscall_getpeername(fd, addr, addrlen, d1, d2, d3) {
                addr >>>= 0;
                addrlen >>>= 0;
                var sock = getSocketFromFD(fd);
                if (!sock.daddr) {
                    return -53
                }
                var errno = writeSockaddr(addr, sock.family, DNS.lookup_name(sock.daddr), sock.dport, addrlen);
                return 0
            }

            function ___syscall_getsockname(fd, addr, addrlen, d1, d2, d3) {
                addr >>>= 0;
                addrlen >>>= 0;
                var sock = getSocketFromFD(fd);
                var errno = writeSockaddr(addr, sock.family, DNS.lookup_name(sock.saddr || "0.0.0.0"), sock.sport, addrlen);
                return 0
            }

            function ___syscall_getsockopt(fd, level, optname, optval, optlen, d1) {
                optval >>>= 0;
                optlen >>>= 0;
                var sock = getSocketFromFD(fd);
                if (level === 1) {
                    if (optname === 4) {
                        HEAP32[optval >>> 2 >>> 0] = sock.error;
                        HEAP32[optlen >>> 2 >>> 0] = 4;
                        sock.error = null;
                        return 0
                    }
                }
                return -50
            }

            function ___syscall_ioctl(fd, op, varargs) {
                varargs >>>= 0;
                SYSCALLS.varargs = varargs;
                return 0
            }

            function ___syscall_lstat64(path, buf) {
                path >>>= 0;
                buf >>>= 0
            }

            function ___syscall_mkdirat(dirfd, path, mode) {
                path >>>= 0
            }

            function ___syscall_newfstatat(dirfd, path, buf, flags) {
                path >>>= 0;
                buf >>>= 0
            }

            function ___syscall_openat(dirfd, path, flags, varargs) {
                path >>>= 0;
                varargs >>>= 0;
                SYSCALLS.varargs = varargs
            }

            function ___syscall_poll(fds, nfds, timeout) {
                fds >>>= 0
            }

            function ___syscall_recvfrom(fd, buf, len, flags, addr, addrlen) {
                buf >>>= 0;
                len >>>= 0;
                addr >>>= 0;
                addrlen >>>= 0;
                var sock = getSocketFromFD(fd);
                var msg = sock.sock_ops.recvmsg(sock, len);
                if (!msg) return 0;
                if (addr) {
                    var errno = writeSockaddr(addr, sock.family, DNS.lookup_name(msg.addr), msg.port, addrlen)
                }
                HEAPU8.set(msg.buffer, buf >>> 0);
                return msg.buffer.byteLength
            }

            function ___syscall_renameat(olddirfd, oldpath, newdirfd, newpath) {
                oldpath >>>= 0;
                newpath >>>= 0
            }

            function ___syscall_rmdir(path) {
                path >>>= 0
            }

            function ___syscall_sendto(fd, message, length, flags, addr, addr_len) {
                message >>>= 0;
                length >>>= 0;
                addr >>>= 0;
                addr_len >>>= 0
            }
            var ___syscall_socket = (domain, type, protocol) => {};

            function ___syscall_stat64(path, buf) {
                path >>>= 0;
                buf >>>= 0
            }

            function ___syscall_statfs64(path, size, buf) {
                path >>>= 0;
                size >>>= 0;
                buf >>>= 0
            }

            function ___syscall_unlinkat(dirfd, path, flags) {
                path >>>= 0
            }
            var nowIsMonotonic = true;
            var __emscripten_get_now_is_monotonic = () => nowIsMonotonic;
            var _abort = () => {
                abort("")
            };

            function _duckdb_web_fs_directory_create(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.createDirectory(Module, path, pathLen)
            }

            function _duckdb_web_fs_directory_exists(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.checkDirectory(Module, path, pathLen)
            }

            function _duckdb_web_fs_directory_list_files(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.listDirectoryEntries(Module, path, pathLen)
            }

            function _duckdb_web_fs_directory_remove(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.removeDirectory(Module, path, pathLen)
            }

            function _duckdb_web_fs_file_close(fileId) {
                return globalThis.DUCKDB_RUNTIME.closeFile(Module, fileId)
            }

            function _duckdb_web_fs_file_exists(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.checkFile(Module, path, pathLen)
            }

            function _duckdb_web_fs_file_get_last_modified_time(fileId) {
                return globalThis.DUCKDB_RUNTIME.getLastFileModificationTime(Module, fileId)
            }

            function _duckdb_web_fs_file_move(from, fromLen, to, toLen) {
                from >>>= 0;
                to >>>= 0;
                return globalThis.DUCKDB_RUNTIME.moveFile(Module, from, fromLen, to, toLen)
            }

            function _duckdb_web_fs_file_open(fileId, flags) {
                return globalThis.DUCKDB_RUNTIME.openFile(Module, fileId, flags)
            }

            function _duckdb_web_fs_file_read(fileId, buf, size, location) {
                buf >>>= 0;
                return globalThis.DUCKDB_RUNTIME.readFile(Module, fileId, buf, size, location)
            }

            function _duckdb_web_fs_file_truncate(fileId, newSize) {
                return globalThis.DUCKDB_RUNTIME.truncateFile(Module, fileId, newSize)
            }

            function _duckdb_web_fs_file_write(fileId, buf, size, location) {
                buf >>>= 0;
                return globalThis.DUCKDB_RUNTIME.writeFile(Module, fileId, buf, size, location)
            }

            function _duckdb_web_fs_get_default_data_protocol(Module) {
                return globalThis.DUCKDB_RUNTIME.getDefaultDataProtocol(Module)
            }

            function _duckdb_web_fs_glob(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.glob(Module, path, pathLen)
            }

            function _duckdb_web_test_platform_feature(feature) {
                return globalThis.DUCKDB_RUNTIME.testPlatformFeature(Module, feature)
            }

            function _duckdb_web_udf_scalar_call(funcId, descPtr, descSize, ptrsPtr, ptrsSize, response) {
                funcId >>>= 0;
                descSize >>>= 0;
                ptrsSize >>>= 0;
                return globalThis.DUCKDB_RUNTIME.callScalarUDF(Module, funcId, descPtr, descSize, ptrsPtr, ptrsSize, response)
            }
            var _emscripten_date_now = () => Date.now();
            var getHeapMax = () => 4294901760;

            function _emscripten_get_heap_max() {
                return getHeapMax()
            }
            var _emscripten_get_now;
            _emscripten_get_now = () => performance.now();

            function _emscripten_memcpy_big(dest, src, num) {
                dest >>>= 0;
                src >>>= 0;
                num >>>= 0;
                return HEAPU8.copyWithin(dest >>> 0, src >>> 0, src + num >>> 0)
            }
            var growMemory = size => {
                var b = wasmMemory.buffer;
                var pages = (size - b.byteLength + 65535) / 65536;
                try {
                    wasmMemory.grow(pages);
                    updateMemoryViews();
                    return 1
                } catch (e) {}
            };

            function _emscripten_resize_heap(requestedSize) {
                requestedSize >>>= 0;
                var oldSize = HEAPU8.length;
                var maxHeapSize = getHeapMax();
                if (requestedSize > maxHeapSize) {
                    return false
                }
                var alignUp = (x, multiple) => x + (multiple - x % multiple) % multiple;
                for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
                    var overGrownHeapSize = oldSize * (1 + .2 / cutDown);
                    overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
                    var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
                    var replacement = growMemory(newSize);
                    if (replacement) {
                        return true
                    }
                }
                return false
            }
            var ENV = {};
            var getExecutableName = () => thisProgram || "./this.program";
            var getEnvStrings = () => {
                if (!getEnvStrings.strings) {
                    var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
                    var env = {
                        "USER": "web_user",
                        "LOGNAME": "web_user",
                        "PATH": "/",
                        "PWD": "/",
                        "HOME": "/home/web_user",
                        "LANG": lang,
                        "_": getExecutableName()
                    };
                    for (var x in ENV) {
                        if (ENV[x] === undefined) delete env[x];
                        else env[x] = ENV[x]
                    }
                    var strings = [];
                    for (var x in env) {
                        strings.push(`${x}=${env[x]}`)
                    }
                    getEnvStrings.strings = strings
                }
                return getEnvStrings.strings
            };
            var stringToAscii = (str, buffer) => {
                for (var i = 0; i < str.length; ++i) {
                    HEAP8[buffer++ >>> 0 >>> 0] = str.charCodeAt(i)
                }
                HEAP8[buffer >>> 0 >>> 0] = 0
            };
            var _environ_get = function(__environ, environ_buf) {
                __environ >>>= 0;
                environ_buf >>>= 0;
                var bufSize = 0;
                getEnvStrings().forEach((string, i) => {
                    var ptr = environ_buf + bufSize;
                    HEAPU32[__environ + i * 4 >>> 2 >>> 0] = ptr;
                    stringToAscii(string, ptr);
                    bufSize += string.length + 1
                });
                return 0
            };
            var _environ_sizes_get = function(penviron_count, penviron_buf_size) {
                penviron_count >>>= 0;
                penviron_buf_size >>>= 0;
                var strings = getEnvStrings();
                HEAPU32[penviron_count >>> 2 >>> 0] = strings.length;
                var bufSize = 0;
                strings.forEach(string => bufSize += string.length + 1);
                HEAPU32[penviron_buf_size >>> 2 >>> 0] = bufSize;
                return 0
            };
            var _proc_exit = code => {
                EXITSTATUS = code;
                if (!keepRuntimeAlive()) {
                    if (Module["onExit"]) Module["onExit"](code);
                    ABORT = true
                }
                quit_(code, new ExitStatus(code))
            };
            var exitJS = (status, implicit) => {
                EXITSTATUS = status;
                _proc_exit(status)
            };
            var _exit = exitJS;
            var _fd_close = fd => 52;

            function _fd_fdstat_get(fd, pbuf) {
                pbuf >>>= 0;
                var rightsBase = 0;
                var rightsInheriting = 0;
                var flags = 0;
                {
                    var type = 2;
                    if (fd == 0) {
                        rightsBase = 2
                    } else if (fd == 1 || fd == 2) {
                        rightsBase = 64
                    }
                    flags = 1
                }
                HEAP8[pbuf >>> 0 >>> 0] = type;
                HEAP16[pbuf + 2 >>> 1 >>> 0] = flags;
                tempI64 = [rightsBase >>> 0, (tempDouble = rightsBase, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[pbuf + 8 >>> 2 >>> 0] = tempI64[0], HEAP32[pbuf + 12 >>> 2 >>> 0] = tempI64[1];
                tempI64 = [rightsInheriting >>> 0, (tempDouble = rightsInheriting, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[pbuf + 16 >>> 2 >>> 0] = tempI64[0], HEAP32[pbuf + 20 >>> 2 >>> 0] = tempI64[1];
                return 0
            }

            function _fd_pread(fd, iov, iovcnt, offset_low, offset_high, pnum) {
                iov >>>= 0;
                iovcnt >>>= 0;
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                pnum >>>= 0;
                return 52
            }

            function _fd_pwrite(fd, iov, iovcnt, offset_low, offset_high, pnum) {
                iov >>>= 0;
                iovcnt >>>= 0;
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                pnum >>>= 0;
                return 52
            }

            function _fd_read(fd, iov, iovcnt, pnum) {
                iov >>>= 0;
                iovcnt >>>= 0;
                pnum >>>= 0;
                return 52
            }

            function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                newOffset >>>= 0;
                return 70
            }
            var _fd_sync = fd => 52;
            var printCharBuffers = [null, [],
                []
            ];
            var printChar = (stream, curr) => {
                var buffer = printCharBuffers[stream];
                if (curr === 0 || curr === 10) {
                    (stream === 1 ? out : err)(UTF8ArrayToString(buffer, 0));
                    buffer.length = 0
                } else {
                    buffer.push(curr)
                }
            };

            function _fd_write(fd, iov, iovcnt, pnum) {
                iov >>>= 0;
                iovcnt >>>= 0;
                pnum >>>= 0;
                var num = 0;
                for (var i = 0; i < iovcnt; i++) {
                    var ptr = HEAPU32[iov >>> 2 >>> 0];
                    var len = HEAPU32[iov + 4 >>> 2 >>> 0];
                    iov += 8;
                    for (var j = 0; j < len; j++) {
                        printChar(fd, HEAPU8[ptr + j >>> 0])
                    }
                    num += len
                }
                HEAPU32[pnum >>> 2 >>> 0] = num;
                return 0
            }

            function _getaddrinfo(node, service, hint, out) {
                node >>>= 0;
                service >>>= 0;
                hint >>>= 0;
                out >>>= 0;
                var addr = 0;
                var port = 0;
                var flags = 0;
                var family = 0;
                var type = 0;
                var proto = 0;
                var ai;

                function allocaddrinfo(family, type, proto, canon, addr, port) {
                    var sa, salen, ai;
                    var errno;
                    salen = family === 10 ? 28 : 16;
                    addr = family === 10 ? inetNtop6(addr) : inetNtop4(addr);
                    sa = _malloc(salen);
                    errno = writeSockaddr(sa, family, addr, port);
                    assert(!errno);
                    ai = _malloc(32);
                    HEAP32[ai + 4 >>> 2 >>> 0] = family;
                    HEAP32[ai + 8 >>> 2 >>> 0] = type;
                    HEAP32[ai + 12 >>> 2 >>> 0] = proto;
                    HEAPU32[ai + 24 >>> 2 >>> 0] = canon;
                    HEAPU32[ai + 20 >>> 2 >>> 0] = sa;
                    if (family === 10) {
                        HEAP32[ai + 16 >>> 2 >>> 0] = 28
                    } else {
                        HEAP32[ai + 16 >>> 2 >>> 0] = 16
                    }
                    HEAP32[ai + 28 >>> 2 >>> 0] = 0;
                    return ai
                }
                if (hint) {
                    flags = HEAP32[hint >>> 2 >>> 0];
                    family = HEAP32[hint + 4 >>> 2 >>> 0];
                    type = HEAP32[hint + 8 >>> 2 >>> 0];
                    proto = HEAP32[hint + 12 >>> 2 >>> 0]
                }
                if (type && !proto) {
                    proto = type === 2 ? 17 : 6
                }
                if (!type && proto) {
                    type = proto === 17 ? 2 : 1
                }
                if (proto === 0) {
                    proto = 6
                }
                if (type === 0) {
                    type = 1
                }
                if (!node && !service) {
                    return -2
                }
                if (flags & ~(1 | 2 | 4 | 1024 | 8 | 16 | 32)) {
                    return -1
                }
                if (hint !== 0 && HEAP32[hint >>> 2 >>> 0] & 2 && !node) {
                    return -1
                }
                if (flags & 32) {
                    return -2
                }
                if (type !== 0 && type !== 1 && type !== 2) {
                    return -7
                }
                if (family !== 0 && family !== 2 && family !== 10) {
                    return -6
                }
                if (service) {
                    service = UTF8ToString(service);
                    port = parseInt(service, 10);
                    if (isNaN(port)) {
                        if (flags & 1024) {
                            return -2
                        }
                        return -8
                    }
                }
                if (!node) {
                    if (family === 0) {
                        family = 2
                    }
                    if ((flags & 1) === 0) {
                        if (family === 2) {
                            addr = _htonl(2130706433)
                        } else {
                            addr = [0, 0, 0, 1]
                        }
                    }
                    ai = allocaddrinfo(family, type, proto, null, addr, port);
                    HEAPU32[out >>> 2 >>> 0] = ai;
                    return 0
                }
                node = UTF8ToString(node);
                addr = inetPton4(node);
                if (addr !== null) {
                    if (family === 0 || family === 2) {
                        family = 2
                    } else if (family === 10 && flags & 8) {
                        addr = [0, 0, _htonl(65535), addr];
                        family = 10
                    } else {
                        return -2
                    }
                } else {
                    addr = inetPton6(node);
                    if (addr !== null) {
                        if (family === 0 || family === 10) {
                            family = 10
                        } else {
                            return -2
                        }
                    }
                }
                if (addr != null) {
                    ai = allocaddrinfo(family, type, proto, node, addr, port);
                    HEAPU32[out >>> 2 >>> 0] = ai;
                    return 0
                }
                if (flags & 4) {
                    return -2
                }
                node = DNS.lookup_name(node);
                addr = inetPton4(node);
                if (family === 0) {
                    family = 2
                } else if (family === 10) {
                    addr = [0, 0, _htonl(65535), addr]
                }
                ai = allocaddrinfo(family, type, proto, null, addr, port);
                HEAPU32[out >>> 2 >>> 0] = ai;
                return 0
            }
            var initRandomFill = () => {
                if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
                    return view => crypto.getRandomValues(view)
                } else if (ENVIRONMENT_IS_NODE) {
                    try {
                        var crypto_module = require("crypto");
                        var randomFillSync = crypto_module["randomFillSync"];
                        if (randomFillSync) {
                            return view => crypto_module["randomFillSync"](view)
                        }
                        var randomBytes = crypto_module["randomBytes"];
                        return view => (view.set(randomBytes(view.byteLength)), view)
                    } catch (e) {}
                }
                abort("initRandomDevice")
            };
            var randomFill = view => (randomFill = initRandomFill())(view);

            function _getentropy(buffer, size) {
                buffer >>>= 0;
                size >>>= 0;
                randomFill(HEAPU8.subarray(buffer >>> 0, buffer + size >>> 0));
                return 0
            }

            function _getnameinfo(sa, salen, node, nodelen, serv, servlen, flags) {
                sa >>>= 0;
                node >>>= 0;
                serv >>>= 0;
                var info = readSockaddr(sa, salen);
                if (info.errno) {
                    return -6
                }
                var port = info.port;
                var addr = info.addr;
                var overflowed = false;
                if (node && nodelen) {
                    var lookup;
                    if (flags & 1 || !(lookup = DNS.lookup_addr(addr))) {
                        if (flags & 8) {
                            return -2
                        }
                    } else {
                        addr = lookup
                    }
                    var numBytesWrittenExclNull = stringToUTF8(addr, node, nodelen);
                    if (numBytesWrittenExclNull + 1 >= nodelen) {
                        overflowed = true
                    }
                }
                if (serv && servlen) {
                    port = "" + port;
                    var numBytesWrittenExclNull = stringToUTF8(port, serv, servlen);
                    if (numBytesWrittenExclNull + 1 >= servlen) {
                        overflowed = true
                    }
                }
                if (overflowed) {
                    return -12
                }
                return 0
            }
            var isLeapYear = year => year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
            var arraySum = (array, index) => {
                var sum = 0;
                for (var i = 0; i <= index; sum += array[i++]) {}
                return sum
            };
            var MONTH_DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var MONTH_DAYS_REGULAR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var addDays = (date, days) => {
                var newDate = new Date(date.getTime());
                while (days > 0) {
                    var leap = isLeapYear(newDate.getFullYear());
                    var currentMonth = newDate.getMonth();
                    var daysInCurrentMonth = (leap ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR)[currentMonth];
                    if (days > daysInCurrentMonth - newDate.getDate()) {
                        days -= daysInCurrentMonth - newDate.getDate() + 1;
                        newDate.setDate(1);
                        if (currentMonth < 11) {
                            newDate.setMonth(currentMonth + 1)
                        } else {
                            newDate.setMonth(0);
                            newDate.setFullYear(newDate.getFullYear() + 1)
                        }
                    } else {
                        newDate.setDate(newDate.getDate() + days);
                        return newDate
                    }
                }
                return newDate
            };
            var lengthBytesUTF8 = str => {
                var len = 0;
                for (var i = 0; i < str.length; ++i) {
                    var c = str.charCodeAt(i);
                    if (c <= 127) {
                        len++
                    } else if (c <= 2047) {
                        len += 2
                    } else if (c >= 55296 && c <= 57343) {
                        len += 4;
                        ++i
                    } else {
                        len += 3
                    }
                }
                return len
            };

            function intArrayFromString(stringy, dontAddNull, length) {
                var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
                var u8array = new Array(len);
                var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
                if (dontAddNull) u8array.length = numBytesWritten;
                return u8array
            }
            var writeArrayToMemory = (array, buffer) => {
                HEAP8.set(array, buffer >>> 0)
            };

            function _strftime(s, maxsize, format, tm) {
                s >>>= 0;
                maxsize >>>= 0;
                format >>>= 0;
                tm >>>= 0;
                var tm_zone = HEAPU32[tm + 40 >>> 2 >>> 0];
                var date = {
                    tm_sec: HEAP32[tm >>> 2 >>> 0],
                    tm_min: HEAP32[tm + 4 >>> 2 >>> 0],
                    tm_hour: HEAP32[tm + 8 >>> 2 >>> 0],
                    tm_mday: HEAP32[tm + 12 >>> 2 >>> 0],
                    tm_mon: HEAP32[tm + 16 >>> 2 >>> 0],
                    tm_year: HEAP32[tm + 20 >>> 2 >>> 0],
                    tm_wday: HEAP32[tm + 24 >>> 2 >>> 0],
                    tm_yday: HEAP32[tm + 28 >>> 2 >>> 0],
                    tm_isdst: HEAP32[tm + 32 >>> 2 >>> 0],
                    tm_gmtoff: HEAP32[tm + 36 >>> 2 >>> 0],
                    tm_zone: tm_zone ? UTF8ToString(tm_zone) : ""
                };
                var pattern = UTF8ToString(format);
                var EXPANSION_RULES_1 = {
                    "%c": "%a %b %d %H:%M:%S %Y",
                    "%D": "%m/%d/%y",
                    "%F": "%Y-%m-%d",
                    "%h": "%b",
                    "%r": "%I:%M:%S %p",
                    "%R": "%H:%M",
                    "%T": "%H:%M:%S",
                    "%x": "%m/%d/%y",
                    "%X": "%H:%M:%S",
                    "%Ec": "%c",
                    "%EC": "%C",
                    "%Ex": "%m/%d/%y",
                    "%EX": "%H:%M:%S",
                    "%Ey": "%y",
                    "%EY": "%Y",
                    "%Od": "%d",
                    "%Oe": "%e",
                    "%OH": "%H",
                    "%OI": "%I",
                    "%Om": "%m",
                    "%OM": "%M",
                    "%OS": "%S",
                    "%Ou": "%u",
                    "%OU": "%U",
                    "%OV": "%V",
                    "%Ow": "%w",
                    "%OW": "%W",
                    "%Oy": "%y"
                };
                for (var rule in EXPANSION_RULES_1) {
                    pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule])
                }
                var WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

                function leadingSomething(value, digits, character) {
                    var str = typeof value == "number" ? value.toString() : value || "";
                    while (str.length < digits) {
                        str = character[0] + str
                    }
                    return str
                }

                function leadingNulls(value, digits) {
                    return leadingSomething(value, digits, "0")
                }

                function compareByDay(date1, date2) {
                    function sgn(value) {
                        return value < 0 ? -1 : value > 0 ? 1 : 0
                    }
                    var compare;
                    if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
                        if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) {
                            compare = sgn(date1.getDate() - date2.getDate())
                        }
                    }
                    return compare
                }

                function getFirstWeekStartDate(janFourth) {
                    switch (janFourth.getDay()) {
                        case 0:
                            return new Date(janFourth.getFullYear() - 1, 11, 29);
                        case 1:
                            return janFourth;
                        case 2:
                            return new Date(janFourth.getFullYear(), 0, 3);
                        case 3:
                            return new Date(janFourth.getFullYear(), 0, 2);
                        case 4:
                            return new Date(janFourth.getFullYear(), 0, 1);
                        case 5:
                            return new Date(janFourth.getFullYear() - 1, 11, 31);
                        case 6:
                            return new Date(janFourth.getFullYear() - 1, 11, 30)
                    }
                }

                function getWeekBasedYear(date) {
                    var thisDate = addDays(new Date(date.tm_year + 1900, 0, 1), date.tm_yday);
                    var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
                    var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
                    var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
                    var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
                    if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
                        if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {
                            return thisDate.getFullYear() + 1
                        }
                        return thisDate.getFullYear()
                    }
                    return thisDate.getFullYear() - 1
                }
                var EXPANSION_RULES_2 = {
                    "%a": date => WEEKDAYS[date.tm_wday].substring(0, 3),
                    "%A": date => WEEKDAYS[date.tm_wday],
                    "%b": date => MONTHS[date.tm_mon].substring(0, 3),
                    "%B": date => MONTHS[date.tm_mon],
                    "%C": date => {
                        var year = date.tm_year + 1900;
                        return leadingNulls(year / 100 | 0, 2)
                    },
                    "%d": date => leadingNulls(date.tm_mday, 2),
                    "%e": date => leadingSomething(date.tm_mday, 2, " "),
                    "%g": date => getWeekBasedYear(date).toString().substring(2),
                    "%G": date => getWeekBasedYear(date),
                    "%H": date => leadingNulls(date.tm_hour, 2),
                    "%I": date => {
                        var twelveHour = date.tm_hour;
                        if (twelveHour == 0) twelveHour = 12;
                        else if (twelveHour > 12) twelveHour -= 12;
                        return leadingNulls(twelveHour, 2)
                    },
                    "%j": date => leadingNulls(date.tm_mday + arraySum(isLeapYear(date.tm_year + 1900) ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR, date.tm_mon - 1), 3),
                    "%m": date => leadingNulls(date.tm_mon + 1, 2),
                    "%M": date => leadingNulls(date.tm_min, 2),
                    "%n": () => "\n",
                    "%p": date => {
                        if (date.tm_hour >= 0 && date.tm_hour < 12) {
                            return "AM"
                        }
                        return "PM"
                    },
                    "%S": date => leadingNulls(date.tm_sec, 2),
                    "%t": () => "\t",
                    "%u": date => date.tm_wday || 7,
                    "%U": date => {
                        var days = date.tm_yday + 7 - date.tm_wday;
                        return leadingNulls(Math.floor(days / 7), 2)
                    },
                    "%V": date => {
                        var val = Math.floor((date.tm_yday + 7 - (date.tm_wday + 6) % 7) / 7);
                        if ((date.tm_wday + 371 - date.tm_yday - 2) % 7 <= 2) {
                            val++
                        }
                        if (!val) {
                            val = 52;
                            var dec31 = (date.tm_wday + 7 - date.tm_yday - 1) % 7;
                            if (dec31 == 4 || dec31 == 5 && isLeapYear(date.tm_year % 400 - 1)) {
                                val++
                            }
                        } else if (val == 53) {
                            var jan1 = (date.tm_wday + 371 - date.tm_yday) % 7;
                            if (jan1 != 4 && (jan1 != 3 || !isLeapYear(date.tm_year))) val = 1
                        }
                        return leadingNulls(val, 2)
                    },
                    "%w": date => date.tm_wday,
                    "%W": date => {
                        var days = date.tm_yday + 7 - (date.tm_wday + 6) % 7;
                        return leadingNulls(Math.floor(days / 7), 2)
                    },
                    "%y": date => (date.tm_year + 1900).toString().substring(2),
                    "%Y": date => date.tm_year + 1900,
                    "%z": date => {
                        var off = date.tm_gmtoff;
                        var ahead = off >= 0;
                        off = Math.abs(off) / 60;
                        off = off / 60 * 100 + off % 60;
                        return (ahead ? "+" : "-") + String("0000" + off).slice(-4)
                    },
                    "%Z": date => date.tm_zone,
                    "%%": () => "%"
                };
                pattern = pattern.replace(/%%/g, "\0\0");
                for (var rule in EXPANSION_RULES_2) {
                    if (pattern.includes(rule)) {
                        pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date))
                    }
                }
                pattern = pattern.replace(/\0\0/g, "%");
                var bytes = intArrayFromString(pattern, false);
                if (bytes.length > maxsize) {
                    return 0
                }
                writeArrayToMemory(bytes, s);
                return bytes.length - 1
            }

            function _strftime_l(s, maxsize, format, tm, loc) {
                s >>>= 0;
                maxsize >>>= 0;
                format >>>= 0;
                tm >>>= 0;
                loc >>>= 0;
                return _strftime(s, maxsize, format, tm)
            }
            var handleException = e => {
                if (e instanceof ExitStatus || e == "unwind") {
                    return EXITSTATUS
                }
                quit_(1, e)
            };
            var getCFunc = ident => {
                var func = Module["_" + ident];
                return func
            };
            var stringToUTF8OnStack = str => {
                var size = lengthBytesUTF8(str) + 1;
                var ret = stackAlloc(size);
                stringToUTF8(str, ret, size);
                return ret
            };
            var ccall = (ident, returnType, argTypes, args, opts) => {
                var toC = {
                    "string": str => {
                        var ret = 0;
                        if (str !== null && str !== undefined && str !== 0) {
                            ret = stringToUTF8OnStack(str)
                        }
                        return ret
                    },
                    "array": arr => {
                        var ret = stackAlloc(arr.length);
                        writeArrayToMemory(arr, ret);
                        return ret
                    }
                };

                function convertReturnValue(ret) {
                    if (returnType === "string") {
                        return UTF8ToString(ret)
                    }
                    if (returnType === "boolean") return Boolean(ret);
                    return ret
                }
                var func = getCFunc(ident);
                var cArgs = [];
                var stack = 0;
                if (args) {
                    for (var i = 0; i < args.length; i++) {
                        var converter = toC[argTypes[i]];
                        if (converter) {
                            if (stack === 0) stack = stackSave();
                            cArgs[i] = converter(args[i])
                        } else {
                            cArgs[i] = args[i]
                        }
                    }
                }
                var ret = func.apply(null, cArgs);

                function onDone(ret) {
                    if (stack !== 0) stackRestore(stack);
                    return convertReturnValue(ret)
                }
                ret = onDone(ret);
                return ret
            };
            var wasmImports = {
                m: __ZN18duckdb_skiplistlib9skip_list19_throw_exceeds_sizeEm,
                fa: ___syscall_bind,
                ea: ___syscall_connect,
                X: ___syscall_faccessat,
                c: ___syscall_fcntl64,
                W: ___syscall_fstat64,
                x: ___syscall_ftruncate64,
                R: ___syscall_getdents64,
                $: ___syscall_getpeername,
                _: ___syscall_getsockname,
                ca: ___syscall_getsockopt,
                r: ___syscall_ioctl,
                T: ___syscall_lstat64,
                S: ___syscall_mkdirat,
                U: ___syscall_newfstatat,
                s: ___syscall_openat,
                da: ___syscall_poll,
                aa: ___syscall_recvfrom,
                P: ___syscall_renameat,
                k: ___syscall_rmdir,
                ba: ___syscall_sendto,
                p: ___syscall_socket,
                V: ___syscall_stat64,
                Y: ___syscall_statfs64,
                l: ___syscall_unlinkat,
                z: __emscripten_get_now_is_monotonic,
                a: _abort,
                H: _duckdb_web_fs_directory_create,
                I: _duckdb_web_fs_directory_exists,
                F: _duckdb_web_fs_directory_list_files,
                G: _duckdb_web_fs_directory_remove,
                i: _duckdb_web_fs_file_close,
                D: _duckdb_web_fs_file_exists,
                w: _duckdb_web_fs_file_get_last_modified_time,
                E: _duckdb_web_fs_file_move,
                L: _duckdb_web_fs_file_open,
                f: _duckdb_web_fs_file_read,
                K: _duckdb_web_fs_file_truncate,
                j: _duckdb_web_fs_file_write,
                M: _duckdb_web_fs_get_default_data_protocol,
                C: _duckdb_web_fs_glob,
                h: _duckdb_web_test_platform_feature,
                N: _duckdb_web_udf_scalar_call,
                J: _emscripten_date_now,
                v: _emscripten_get_heap_max,
                d: _emscripten_get_now,
                ha: _emscripten_memcpy_big,
                ia: _emscripten_resize_heap,
                t: _environ_get,
                u: _environ_sizes_get,
                Z: _exit,
                e: _fd_close,
                ga: _fd_fdstat_get,
                A: _fd_pread,
                y: _fd_pwrite,
                q: _fd_read,
                B: _fd_seek,
                Q: _fd_sync,
                g: _fd_write,
                o: _getaddrinfo,
                O: _getentropy,
                n: _getnameinfo,
                b: _strftime_l
            };
            var wasmExports = createWasm();
            var _main = Module["_main"] = (a0, a1) => (_main = Module["_main"] = wasmExports["la"])(a0, a1);
            var _duckdb_web_fs_glob_add_path = Module["_duckdb_web_fs_glob_add_path"] = a0 => (_duckdb_web_fs_glob_add_path = Module["_duckdb_web_fs_glob_add_path"] = wasmExports["na"])(a0);
            var _duckdb_web_clear_response = Module["_duckdb_web_clear_response"] = () => (_duckdb_web_clear_response = Module["_duckdb_web_clear_response"] = wasmExports["oa"])();
            var _duckdb_web_fail_with = Module["_duckdb_web_fail_with"] = a0 => (_duckdb_web_fail_with = Module["_duckdb_web_fail_with"] = wasmExports["pa"])(a0);
            var _duckdb_web_reset = Module["_duckdb_web_reset"] = a0 => (_duckdb_web_reset = Module["_duckdb_web_reset"] = wasmExports["qa"])(a0);
            var _duckdb_web_connect = Module["_duckdb_web_connect"] = () => (_duckdb_web_connect = Module["_duckdb_web_connect"] = wasmExports["ra"])();
            var _duckdb_web_disconnect = Module["_duckdb_web_disconnect"] = a0 => (_duckdb_web_disconnect = Module["_duckdb_web_disconnect"] = wasmExports["sa"])(a0);
            var _duckdb_web_flush_files = Module["_duckdb_web_flush_files"] = () => (_duckdb_web_flush_files = Module["_duckdb_web_flush_files"] = wasmExports["ta"])();
            var _duckdb_web_flush_file = Module["_duckdb_web_flush_file"] = a0 => (_duckdb_web_flush_file = Module["_duckdb_web_flush_file"] = wasmExports["ua"])(a0);
            var _duckdb_web_open = Module["_duckdb_web_open"] = (a0, a1) => (_duckdb_web_open = Module["_duckdb_web_open"] = wasmExports["va"])(a0, a1);
            var _duckdb_web_get_global_file_info = Module["_duckdb_web_get_global_file_info"] = (a0, a1) => (_duckdb_web_get_global_file_info = Module["_duckdb_web_get_global_file_info"] = wasmExports["wa"])(a0, a1);
            var _duckdb_web_collect_file_stats = Module["_duckdb_web_collect_file_stats"] = (a0, a1, a2) => (_duckdb_web_collect_file_stats = Module["_duckdb_web_collect_file_stats"] = wasmExports["xa"])(a0, a1, a2);
            var _duckdb_web_export_file_stats = Module["_duckdb_web_export_file_stats"] = (a0, a1) => (_duckdb_web_export_file_stats = Module["_duckdb_web_export_file_stats"] = wasmExports["ya"])(a0, a1);
            var _duckdb_web_fs_drop_file = Module["_duckdb_web_fs_drop_file"] = (a0, a1) => (_duckdb_web_fs_drop_file = Module["_duckdb_web_fs_drop_file"] = wasmExports["za"])(a0, a1);
            var _duckdb_web_fs_drop_files = Module["_duckdb_web_fs_drop_files"] = a0 => (_duckdb_web_fs_drop_files = Module["_duckdb_web_fs_drop_files"] = wasmExports["Aa"])(a0);
            var _duckdb_web_fs_glob_file_infos = Module["_duckdb_web_fs_glob_file_infos"] = (a0, a1) => (_duckdb_web_fs_glob_file_infos = Module["_duckdb_web_fs_glob_file_infos"] = wasmExports["Ba"])(a0, a1);
            var _duckdb_web_fs_get_file_info_by_id = Module["_duckdb_web_fs_get_file_info_by_id"] = (a0, a1, a2) => (_duckdb_web_fs_get_file_info_by_id = Module["_duckdb_web_fs_get_file_info_by_id"] = wasmExports["Ca"])(a0, a1, a2);
            var _duckdb_web_fs_get_file_info_by_name = Module["_duckdb_web_fs_get_file_info_by_name"] = (a0, a1, a2) => (_duckdb_web_fs_get_file_info_by_name = Module["_duckdb_web_fs_get_file_info_by_name"] = wasmExports["Da"])(a0, a1, a2);
            var _duckdb_web_fs_register_file_url = Module["_duckdb_web_fs_register_file_url"] = (a0, a1, a2, a3, a4) => (_duckdb_web_fs_register_file_url = Module["_duckdb_web_fs_register_file_url"] = wasmExports["Ea"])(a0, a1, a2, a3, a4);
            var _duckdb_web_fs_register_file_buffer = Module["_duckdb_web_fs_register_file_buffer"] = (a0, a1, a2, a3) => (_duckdb_web_fs_register_file_buffer = Module["_duckdb_web_fs_register_file_buffer"] = wasmExports["Fa"])(a0, a1, a2, a3);
            var _duckdb_web_copy_file_to_buffer = Module["_duckdb_web_copy_file_to_buffer"] = (a0, a1) => (_duckdb_web_copy_file_to_buffer = Module["_duckdb_web_copy_file_to_buffer"] = wasmExports["Ga"])(a0, a1);
            var _duckdb_web_copy_file_to_path = Module["_duckdb_web_copy_file_to_path"] = (a0, a1, a2) => (_duckdb_web_copy_file_to_path = Module["_duckdb_web_copy_file_to_path"] = wasmExports["Ha"])(a0, a1, a2);
            var _duckdb_web_get_version = Module["_duckdb_web_get_version"] = a0 => (_duckdb_web_get_version = Module["_duckdb_web_get_version"] = wasmExports["Ia"])(a0);
            var _duckdb_web_get_feature_flags = Module["_duckdb_web_get_feature_flags"] = () => (_duckdb_web_get_feature_flags = Module["_duckdb_web_get_feature_flags"] = wasmExports["Ja"])();
            var _duckdb_web_tokenize = Module["_duckdb_web_tokenize"] = (a0, a1) => (_duckdb_web_tokenize = Module["_duckdb_web_tokenize"] = wasmExports["Ka"])(a0, a1);
            var _duckdb_web_udf_scalar_create = Module["_duckdb_web_udf_scalar_create"] = (a0, a1, a2) => (_duckdb_web_udf_scalar_create = Module["_duckdb_web_udf_scalar_create"] = wasmExports["La"])(a0, a1, a2);
            var _duckdb_web_prepared_create = Module["_duckdb_web_prepared_create"] = (a0, a1, a2) => (_duckdb_web_prepared_create = Module["_duckdb_web_prepared_create"] = wasmExports["Ma"])(a0, a1, a2);
            var _duckdb_web_prepared_close = Module["_duckdb_web_prepared_close"] = (a0, a1, a2) => (_duckdb_web_prepared_close = Module["_duckdb_web_prepared_close"] = wasmExports["Na"])(a0, a1, a2);
            var _duckdb_web_prepared_run = Module["_duckdb_web_prepared_run"] = (a0, a1, a2, a3) => (_duckdb_web_prepared_run = Module["_duckdb_web_prepared_run"] = wasmExports["Oa"])(a0, a1, a2, a3);
            var _duckdb_web_prepared_send = Module["_duckdb_web_prepared_send"] = (a0, a1, a2, a3) => (_duckdb_web_prepared_send = Module["_duckdb_web_prepared_send"] = wasmExports["Pa"])(a0, a1, a2, a3);
            var _duckdb_web_query_run = Module["_duckdb_web_query_run"] = (a0, a1, a2) => (_duckdb_web_query_run = Module["_duckdb_web_query_run"] = wasmExports["Qa"])(a0, a1, a2);
            var _duckdb_web_query_run_buffer = Module["_duckdb_web_query_run_buffer"] = (a0, a1, a2, a3) => (_duckdb_web_query_run_buffer = Module["_duckdb_web_query_run_buffer"] = wasmExports["Ra"])(a0, a1, a2, a3);
            var _duckdb_web_pending_query_start = Module["_duckdb_web_pending_query_start"] = (a0, a1, a2) => (_duckdb_web_pending_query_start = Module["_duckdb_web_pending_query_start"] = wasmExports["Sa"])(a0, a1, a2);
            var _duckdb_web_pending_query_poll = Module["_duckdb_web_pending_query_poll"] = (a0, a1, a2) => (_duckdb_web_pending_query_poll = Module["_duckdb_web_pending_query_poll"] = wasmExports["Ta"])(a0, a1, a2);
            var _duckdb_web_pending_query_cancel = Module["_duckdb_web_pending_query_cancel"] = (a0, a1) => (_duckdb_web_pending_query_cancel = Module["_duckdb_web_pending_query_cancel"] = wasmExports["Ua"])(a0, a1);
            var _duckdb_web_query_fetch_results = Module["_duckdb_web_query_fetch_results"] = (a0, a1) => (_duckdb_web_query_fetch_results = Module["_duckdb_web_query_fetch_results"] = wasmExports["Va"])(a0, a1);
            var _duckdb_web_get_tablenames = Module["_duckdb_web_get_tablenames"] = (a0, a1, a2) => (_duckdb_web_get_tablenames = Module["_duckdb_web_get_tablenames"] = wasmExports["Wa"])(a0, a1, a2);
            var _duckdb_web_insert_arrow_from_ipc_stream = Module["_duckdb_web_insert_arrow_from_ipc_stream"] = (a0, a1, a2, a3, a4) => (_duckdb_web_insert_arrow_from_ipc_stream = Module["_duckdb_web_insert_arrow_from_ipc_stream"] = wasmExports["Xa"])(a0, a1, a2, a3, a4);
            var _duckdb_web_insert_csv_from_path = Module["_duckdb_web_insert_csv_from_path"] = (a0, a1, a2, a3) => (_duckdb_web_insert_csv_from_path = Module["_duckdb_web_insert_csv_from_path"] = wasmExports["Ya"])(a0, a1, a2, a3);
            var _duckdb_web_insert_json_from_path = Module["_duckdb_web_insert_json_from_path"] = (a0, a1, a2, a3) => (_duckdb_web_insert_json_from_path = Module["_duckdb_web_insert_json_from_path"] = wasmExports["Za"])(a0, a1, a2, a3);
            var _malloc = Module["_malloc"] = a0 => (_malloc = Module["_malloc"] = wasmExports["bb"])(a0);
            var _free = Module["_free"] = a0 => (_free = Module["_free"] = wasmExports["cb"])(a0);
            var stackSave = () => (stackSave = wasmExports["eb"])();
            var stackRestore = a0 => (stackRestore = wasmExports["fb"])(a0);
            var stackAlloc = a0 => (stackAlloc = wasmExports["gb"])(a0);

            function applySignatureConversions(wasmExports) {
                wasmExports = Object.assign({}, wasmExports);
                var makeWrapper_p = f => () => f() >>> 0;
                var makeWrapper_pp = f => a0 => f(a0) >>> 0;
                wasmExports["__errno_location"] = makeWrapper_p(wasmExports["__errno_location"]);
                wasmExports["bb"] = makeWrapper_pp(wasmExports["bb"]);
                wasmExports["eb"] = makeWrapper_p(wasmExports["eb"]);
                wasmExports["gb"] = makeWrapper_pp(wasmExports["gb"]);
                return wasmExports
            }
            Module["stackAlloc"] = stackAlloc;
            Module["stackSave"] = stackSave;
            Module["stackRestore"] = stackRestore;
            Module["ccall"] = ccall;
            var calledRun;
            dependenciesFulfilled = function runCaller() {
                if (!calledRun) run();
                if (!calledRun) dependenciesFulfilled = runCaller
            };

            function callMain() {
                var entryFunction = _main;
                var argc = 0;
                var argv = 0;
                try {
                    var ret = entryFunction(argc, argv);
                    exitJS(ret, true);
                    return ret
                } catch (e) {
                    return handleException(e)
                }
            }

            function run() {
                if (runDependencies > 0) {
                    return
                }
                preRun();
                if (runDependencies > 0) {
                    return
                }

                function doRun() {
                    if (calledRun) return;
                    calledRun = true;
                    Module["calledRun"] = true;
                    if (ABORT) return;
                    initRuntime();
                    preMain();
                    readyPromiseResolve(Module);
                    if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                    if (shouldRunNow) callMain();
                    postRun()
                }
                if (Module["setStatus"]) {
                    Module["setStatus"]("Running...");
                    setTimeout(function() {
                        setTimeout(function() {
                            Module["setStatus"]("")
                        }, 1);
                        doRun()
                    }, 1)
                } else {
                    doRun()
                }
            }
            if (Module["preInit"]) {
                if (typeof Module["preInit"] == "function") Module["preInit"] = [Module["preInit"]];
                while (Module["preInit"].length > 0) {
                    Module["preInit"].pop()()
                }
            }
            var shouldRunNow = true;
            if (Module["noInitialRun"]) shouldRunNow = false;
            run();


            return moduleArg.ready
        }

    );
})();
if (typeof exports === 'object' && typeof module === 'object')
    module.exports = DuckDB;
else if (typeof define === 'function' && define['amd'])
    define([], () => DuckDB);
